import React from 'react';
import { StyledStoreInfoList, StyledStoreInfoText } from './styles';

type OwnProps = {
  storeInfo?: (string | null)[] | null;
};

export const StoreInfoList = React.memo(
  ({ storeInfo }: OwnProps) =>
    storeInfo && storeInfo.length && storeInfo.filter(item => item).length ? (
      <StyledStoreInfoList>
        {storeInfo.map((value, index) => (
          <StyledStoreInfoText
            // eslint-disable-next-line react/no-array-index-key
            key={`store-info-${index}`}
          >
            <span>{value}</span>
          </StyledStoreInfoText>
        ))}
      </StyledStoreInfoList>
    ) : null,
  ({ storeInfo: prevStoreInfo }, { storeInfo: nextStoreInfo }) => {
    if (!prevStoreInfo && !nextStoreInfo) {
      return true;
    }

    if (
      (!prevStoreInfo && nextStoreInfo) ||
      (prevStoreInfo && !nextStoreInfo) ||
      prevStoreInfo?.length !== nextStoreInfo?.length
    ) {
      return false;
    }

    if (prevStoreInfo && nextStoreInfo) {
      return prevStoreInfo.every((value, i) => value === nextStoreInfo[i]);
    }

    return false;
  }
);
